import { FC } from 'react';
import { useHistory, useParams } from 'react-router';

import Button from 'components/_core/Button';
import SunshineModal from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';
import { useModal } from 'components/ModalProvider/hooks';
import useToast from 'components/ToastProvider/useToast';

import * as routes from '../../../../routes';
import { RouteState } from '../..';
import useDeleteRecurringExport from './hooks/useDeleteRecurringExport';
import locales from './locales';

const CancelExportModal: FC = () => {
  const { hideModal } = useModal();
  const { showToast } = useToast();
  const { exportId } = useParams<RouteState>();
  const history = useHistory();
  const [deleteRecurringExport, { loading }] =
    useDeleteRecurringExport(exportId);

  const confirmDeleteExport = async () => {
    try {
      await deleteRecurringExport();

      hideModal();
      history.replace(routes.exports);
    } catch (error) {
      showToast({ message: locales.cancelError, type: 'error' });
    }
  };

  return (
    <SunshineModal isOpen onClose={hideModal}>
      <SunshineModal.Header />

      <SunshineModal.Body>
        <SunshineModal.Title>{locales.title}</SunshineModal.Title>
        <Text>{locales.description}</Text>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        <Button
          isDisabled={loading}
          onClick={hideModal}
          variant="inline-secondary"
        >
          {locales.cancel}
        </Button>

        <Button
          icon="arrow-right"
          isLoading={loading}
          onClick={confirmDeleteExport}
          variant="danger"
        >
          {locales.confirm}
        </Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};

export default CancelExportModal;
